import bodymovin from 'lottie-web';
import {hide, show} from '../helpers/ActionHelper';

export class ElementorLottieComponent {
  selector;

  container;

  animationMap;

  constructor(selector) {
    this.selector = selector;
    this.container = document.querySelector(selector);
    this.animationMap = new Map();
  }

  async initialize() {
    if (!this.container) {
      return;
    }

    await this.destoroyElementorAnimations();
    this.reinitElements();

    this.addEventListeners();
  }

  async destoroyElementorAnimations() {
    const animations = await this.getElementorAnimations();
    animations.forEach((animation) => {
      if (animation.wrapper.closest(this.selector)) {
        animation.destroy();
      }
    });
  }

  reinitElements() {
    const elements = [...this.container.querySelectorAll(`${this.selector}__lottie`)];
    for (let i in elements) {
      const dataSettings = elements[i].hasAttribute('data-settings') ? elements[i].getAttribute('data-settings') : '';
      if (!dataSettings.length) {
        continue;
      }

      const json = JSON.parse(dataSettings);

      let animatedItem = bodymovin.loadAnimation({
        container: elements[i],
        animType: 'svg',
        loop: false,
        autoplay: false,
        path: json.source_json.url
      });

      animatedItem.addEventListener('complete', (e) => this.animationCompletedHandler(animatedItem));

      this.animationMap.set(i, animatedItem);
    }

    elements.forEach((element) => {

    });
  }


  async getElementorAnimations() {
    return new Promise((resolve) => {
      let animations = [];
      let i = 0;
      const interval = setInterval(() => {
        animations = [...window.lottie.getRegisteredAnimations()];
        if (animations.length || i >= 19) {
          clearInterval(interval);
          resolve(animations);
        }

        i++;
      }, 100);
    });
  }

  addEventListeners() {
    const playButtons = [...this.container.querySelectorAll('.js-lottie-play-btn img')];
    playButtons.forEach((playButton) => {
      playButton.addEventListener('click', (e) => this.playButtonClickHandler(e));
    });
  }

  playButtonClickHandler(e) {
    const container = e.target.closest('.passwordless-video-carousel__item');
    if (!container) {
      return;
    }

    const containerWrapper = container.closest('.elementor-container');
    const index = [...containerWrapper.children].indexOf(container);
    if (index === -1) {
      return;
    }

    this.animationMap.get(`${index}`).play();
    hide(e.target);
  }

  animationCompletedHandler(animatedItem) {
    console.log(animatedItem);

    animatedItem.stop();

    const container = animatedItem.wrapper.closest('.passwordless-video-carousel__item');
    if (!container) {
      return;
    }

    const playButton = container.querySelector('.js-lottie-play-btn img');
    if (playButton) {
      show(playButton);
    }
  }
}